const _ = 500, O = 25.4, R = [208, 233, 245], A = [85, 100, 109];
export {
  _ as DEFAULT_TRANSFORM_DURATION,
  R as HOOPS_DEFAULT_FACE_COLOR_RGB,
  A as HOOPS_DEFAULT_LINE_COLOR_RGB,
  O as MM_IN_INCH
};
//# sourceMappingURL=HoopsViewer.consts.mjs.map
